import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const PAGE_SIZE = 50

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
    if (current >= total - 3) return [1, '...', total-4, total-3, total-2, total-1, total]
    return [1, '...', current-1, current, current+1, '...', total]
}

class AlertasComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            elements: [],
            currentAlerta: '',
            allSociedades: [],
            allClientes: [],
            clientes: [],
            selectedPropietarios: '',
            loading: false,
            loaded: false,
            pages: {},      // { [encabezado]: currentPage }
            collapsed: {}, // { [encabezado]: true/false }
        }
        this.expand = this.expand.bind(this)
        this.cargarDatos = this.cargarDatos.bind(this)
        this.descargarCSV = this.descargarCSV.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_ALERTAS")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        // Solo cargar sociedades y clientes para poblar los filtros
        let sociedadesArray = []
        ElementsDataService.retrieveAllElements("sociedades")
            .then(response => {
                response.data.map(e => sociedadesArray.push({ id: e.id, razonSocial: e.razonSocial, rfc: e.rfc, clientes: e.clientes }))
                this.setState({ allSociedades: sociedadesArray })
                return ElementsDataService.retrieveAllElements("clientes")
            })
            .then(resp => {
                this.setState({ allClientes: resp.data })
            })
            .catch(() => {})
    }

    cargarDatos() {
        this.setState({ loading: true, loaded: false })
        let sociedadesArray = []
        ElementsDataService.retrieveAllElements("sociedades")
            .then(response => {
                response.data.map(e => sociedadesArray.push({ id: e.id, razonSocial: e.razonSocial, rfc: e.rfc, clientes: e.clientes }))
                this.setState({ allSociedades: sociedadesArray })
                return ElementsDataService.retrieveAllElements("clientes")
            })
            .then(resp => {
                this.setState({ allClientes: resp.data })
                return ElementsDataService.retrieveAllElements("alertas")
            })
            .then(resp => {
                this.setState({ elements: resp.data, loading: false, loaded: true })
            })
            .catch(() => this.setState({ loading: false }))
    }

    expand(diccionario, mensaje) {
        let newString = ""
        let map = new Map(Object.entries(diccionario))
        for (let i = 0; i < mensaje.length; i++) {
            let c = mensaje[i]
            if (c === '^') { c = mensaje[++i]; newString = newString.concat(map.get(c)) }
            else newString = newString.concat(c)
        }
        return newString
    }

    descargarCSV(csvStr) {
        const element = document.createElement("a")
        const file = new Blob([csvStr], { type: 'text/plain' })
        element.href = URL.createObjectURL(file)
        const d = new Date()
        element.download = `Reporte Alertas ${d.toLocaleDateString()}T${d.toLocaleTimeString()}.csv`
        document.body.appendChild(element)
        element.click()
    }

    render() {
        const { elements, loading, loaded, currentAlerta, allSociedades, allClientes, clientes, selectedPropietarios } = this.state

        const roles = [
            { id: 1, nombre: 'Socio' }, { id: 2, nombre: 'Accionista' }, { id: 3, nombre: 'Asociado' },
            { id: 4, nombre: 'Comisario' }, { id: 5, nombre: 'Administrador General Único' },
            { id: 6, nombre: 'Poderdante' }, { id: 7, nombre: 'Apoderado' },
            { id: 8, nombre: 'Presidente Consejo Adm.' }, { id: 9, nombre: 'Delegado Especial' },
            { id: 10, nombre: 'Socio Administrador' }, { id: 11, nombre: 'Escrutador' },
            { id: 12, nombre: 'Gerente' }, { id: 13, nombre: 'Director General' }, { id: 15, nombre: 'Otro' },
        ]
        const propietarios = [{ id: 1, nombre: 'ST' }, { id: 2, nombre: 'SPH' }]

        let mensajesAlertas = []
        let alertasTables = []
        let csvStr = ""
        let totalAlertas = 0

        elements && elements.forEach(listadoAlertas => {
            Object.values(listadoAlertas.mensajes).forEach(m => mensajesAlertas.push(m))
            let tipoObjeto = listadoAlertas.objectType === 'sociedad' ? 'Sociedad' : 'Persona Física'
            let nameHeader = listadoAlertas.objectType === 'sociedad' ? 'Razón Social' : 'Nombre'
            let url = listadoAlertas.objectType === 'sociedad' ? 'sociedades' : 'personas-fisicas'
            let counter = 0
            let alertasRows = []

            let header = `"${listadoAlertas.encabezado}",,,\n`
            header += `#,"${nameHeader}",Alerta,`
            header += listadoAlertas.objectType === 'personaFisica' ? "Sociedades,Roles,Cliente,Propietario" : "Cliente,Propietario"
            header += "\n"
            let content = ""

            listadoAlertas.alertas.forEach(alerta => {
                let mensajeAlerta = this.expand(listadoAlertas.mensajes, alerta.mensaje)
                let clienteFlag = clientes.length ? false : true
                let propietarioFlag = selectedPropietarios ? false : true

                if (listadoAlertas.objectType === 'personaFisica') {
                    alerta.idsSociedades.map(sr => {
                        let soc = allSociedades.find(x => x.id === sr.sociedadId)
                        soc && soc.clientes && soc.clientes.map(cm => {
                            clientes.forEach(cs => { if (cs.id === cm.id) clienteFlag = true })
                            let cli = allClientes.find(x => x.id === cm.id)
                            if (cli && selectedPropietarios === cli.propietario) propietarioFlag = true
                        })
                    })
                }
                if (listadoAlertas.objectType === 'sociedad') {
                    const soc = allSociedades.find(x => x.id === alerta.objectId)
                    soc && soc.clientes && soc.clientes.map(cm => {
                        let cli = allClientes.find(x => x.id === cm.id)
                        if (cli && selectedPropietarios === cli.propietario) propietarioFlag = true
                        clientes.forEach(cs => { if (cli && cs.id === cli.id) clienteFlag = true })
                    })
                }

                if (mensajeAlerta.includes(currentAlerta) && clienteFlag && propietarioFlag) {
                    counter++
                    totalAlertas++
                    content += `${counter},`
                    content += `"${alerta.name}",`
                    content += `"${mensajeAlerta}",`

                    alertasRows.push(
                        <tr key={alerta.objectId + mensajeAlerta} style={styles.tr}>
                            <td style={styles.tdNum}>{counter}</td>
                            <td style={styles.td}>
                                <Link to={`/${url}/reportes/${alerta.objectId}`} style={styles.link}>
                                    {alerta.name}
                                </Link>
                            </td>
                            <td style={styles.td}>
                                <span style={styles.alertaBadge}>{mensajeAlerta}</span>
                            </td>
                            {listadoAlertas.objectType === 'personaFisica' && (
                                <td style={styles.td}>
                                    {alerta.idsSociedades.map((sr, idx) => {
                                        let soc = allSociedades.find(x => x.id === sr.sociedadId)
                                        return (
                                            <div key={idx} style={styles.socBlock}>
                                                {soc && <Link to={`/sociedades/reportes/${soc.id}`} style={styles.link}>{soc.razonSocial}</Link>}
                                                <div style={styles.roles}>
                                                    {sr.roles.map(r => {
                                                        let rn = roles.find(x => x.id === r)
                                                        return <span key={r} style={styles.roleBadge}>{rn?.nombre}</span>
                                                    })}
                                                </div>
                                                {soc?.clientes?.map((cm, i) => {
                                                    let cli = allClientes.find(x => x.id === cm.id)
                                                    return cli ? <span key={i} style={styles.clienteBadge}>{cli.nombreCliente} · {cli.propietario}</span> : null
                                                })}
                                            </div>
                                        )
                                    })}
                                </td>
                            )}
                            {listadoAlertas.objectType === 'sociedad' && (
                                <td style={styles.td}>
                                    {allSociedades.find(x => x.id === alerta.objectId)?.clientes?.map((cm, i) => {
                                        let cli = allClientes.find(x => x.id === cm.id)
                                        return cli ? <div key={i} style={styles.clienteBadge}>{cli.nombreCliente} · {cli.propietario}</div> : null
                                    })}
                                </td>
                            )}
                        </tr>
                    )
                    content += "\n"
                }
            })

            if (content) csvStr += header + content
            if (alertasRows.length) {
                const enc = listadoAlertas.encabezado
                const curPage = (this.state.pages[enc] || 1)
                const totalPages = Math.max(1, Math.ceil(alertasRows.length / PAGE_SIZE))
                const page = Math.min(curPage, totalPages)
                const pageRows = alertasRows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

                const isCollapsed = this.state.collapsed[enc] !== false  // default collapsed = true

                alertasTables.push(
                    <div key={enc} style={styles.tableWrap}>
                        <div
                            style={{...styles.tableHeader, cursor: 'pointer', userSelect: 'none'}}
                            onClick={() => this.setState({ collapsed: {...this.state.collapsed, [enc]: !isCollapsed} })}
                        >
                            <div style={styles.tableHeaderLeft}>
                                <span style={styles.tableTypeTag}>{tipoObjeto}</span>
                                <h3 style={styles.tableTitle}>{enc}</h3>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <span style={styles.countBadge}>{alertasRows.length} alertas</span>
                                <span style={{ color: '#94a3b8', fontSize: '0.9rem', transition: 'transform 0.2s', transform: isCollapsed ? 'rotate(0deg)' : 'rotate(180deg)', display: 'inline-block' }}>▼</span>
                            </div>
                        </div>
                        {!isCollapsed && <div style={styles.tableScroll}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.thead}>
                                        <th style={styles.th}>#</th>
                                        <th style={styles.th}>{nameHeader}</th>
                                        <th style={styles.th}>Alerta</th>
                                        {listadoAlertas.objectType === 'personaFisica' && <th style={styles.th}>Sociedades / Roles / Cliente</th>}
                                        {listadoAlertas.objectType === 'sociedad' && <th style={styles.th}>Cliente · Propietario</th>}
                                    </tr>
                                </thead>
                                <tbody>{pageRows}</tbody>
                            </table>
                        </div>}
                        {!isCollapsed && totalPages > 1 && (
                            <div style={styles.pagination}>
                                <span style={styles.pageInfo}>
                                    Mostrando {(page-1)*PAGE_SIZE+1}–{Math.min(page*PAGE_SIZE, alertasRows.length)} de {alertasRows.length}
                                </span>
                                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                    <button style={styles.pageBtn(page===1)} onClick={() => this.setState({ pages: {...this.state.pages, [enc]: 1} })} disabled={page===1}>«</button>
                                    <button style={styles.pageBtn(page===1)} onClick={() => this.setState({ pages: {...this.state.pages, [enc]: page-1} })} disabled={page===1}>‹</button>
                                    {getPageNumbers(page, totalPages).map((p, i) =>
                                        p === '...'
                                            ? <span key={i} style={{ padding: '0 4px', alignSelf: 'center', color: '#94a3b8' }}>…</span>
                                            : <button key={p} style={page===p ? styles.pageBtnActive : styles.pageBtn(false)} onClick={() => this.setState({ pages: {...this.state.pages, [enc]: p} })}>{p}</button>
                                    )}
                                    <button style={styles.pageBtn(page===totalPages)} onClick={() => this.setState({ pages: {...this.state.pages, [enc]: page+1} })} disabled={page===totalPages}>›</button>
                                    <button style={styles.pageBtn(page===totalPages)} onClick={() => this.setState({ pages: {...this.state.pages, [enc]: totalPages} })} disabled={page===totalPages}>»</button>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        })

        const hasFilters = currentAlerta || selectedPropietarios || clientes.length

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .alertas-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .filter-select {
                        width: 100%; padding: 10px 14px;
                        background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; font-size: 0.85rem; color: #334155;
                        outline: none; cursor: pointer; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                    }
                    .filter-select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .filter-input {
                        width: 100%; padding: 10px 14px;
                        background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; font-size: 0.85rem; color: #334155;
                        outline: none; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                    }
                    .filter-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .alertas-tr:hover td { background: #f8faff !important; }
                    .btn-buscar {
                        padding: 10px 24px;
                        background: linear-gradient(135deg, #2563eb, #3b82f6);
                        border: none; border-radius: 10px;
                        color: white; font-weight: 600; font-size: 0.85rem;
                        cursor: pointer; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                        box-shadow: 0 4px 12px rgba(59,130,246,0.3);
                    }
                    .btn-buscar:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(59,130,246,0.4); }
                    .btn-buscar:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
                    .btn-csv {
                        padding: 10px 18px;
                        background: white; border: 1px solid #e2e8f0;
                        border-radius: 10px; color: #475569;
                        font-size: 0.82rem; font-weight: 600;
                        cursor: pointer; transition: all 0.2s;
                        font-family: 'Inter', sans-serif;
                        display: flex; align-items: center; gap: 6px;
                    }
                    .btn-csv:hover { border-color: #3b82f6; color: #3b82f6; background: #f0f7ff; }
                    .cliente-chip {
                        display: inline-flex; align-items: center; gap: 6px;
                        background: #f1f5f9; border: 1px solid #e2e8f0;
                        border-radius: 20px; padding: 4px 10px 4px 4px;
                        font-size: 0.78rem; color: #334155; margin: 2px;
                    }
                    .cliente-chip button {
                        background: #cbd5e1; border: none; border-radius: 50%;
                        width: 16px; height: 16px; cursor: pointer;
                        display: flex; align-items: center; justify-content: center;
                        font-size: 0.65rem; color: #475569; padding: 0;
                    }
                    .cliente-chip button:hover { background: #ef4444; color: white; }
                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(12px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .table-anim { animation: fadeInUp 0.4s ease forwards; }
                    .skeleton { background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%); background-size: 200% 100%; animation: shimmer 1.5s infinite; border-radius: 6px; }
                    @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
                `}</style>

                <div className="alertas-root" style={styles.inner}>

                    {/* Header */}
                    <div style={styles.pageHeader}>
                        <div>
                            <h1 style={styles.pageTitle}>Alertas</h1>
                            <p style={styles.pageSubtitle}>Selecciona los filtros y presiona Buscar para cargar las alertas</p>
                        </div>
                        {loaded && csvStr && (
                            <button className="btn-csv" onClick={() => this.descargarCSV(csvStr)}>
                                ⬇ Exportar CSV
                            </button>
                        )}
                    </div>

                    {/* Filtros */}
                    <div style={styles.filtersCard}>
                        <div style={styles.filtersGrid}>

                            {/* Tipo de alerta */}
                            <div style={styles.filterGroup}>
                                <label style={styles.filterLabel}>Tipo de alerta</label>
                                <select className="filter-select" value={currentAlerta}
                                    onChange={e => this.setState({ currentAlerta: e.target.value })}>
                                    <option value="">Todas las alertas</option>
                                    {mensajesAlertas.length === 0 && !loaded
                                        ? null
                                        : mensajesAlertas.map((m, i) => <option key={i} value={m}>{m}</option>)
                                    }
                                </select>
                            </div>

                            {/* Propietario */}
                            <div style={styles.filterGroup}>
                                <label style={styles.filterLabel}>Propietario</label>
                                <select className="filter-select" value={selectedPropietarios}
                                    onChange={e => this.setState({ selectedPropietarios: e.target.value })}>
                                    <option value="">Todos</option>
                                    {propietarios.map(p => <option key={p.id} value={p.nombre}>{p.nombre}</option>)}
                                </select>
                            </div>

                            {/* Proyectos */}
                            <div style={styles.filterGroup}>
                                <label style={styles.filterLabel}>Proyecto</label>
                                <select className="filter-select"
                                    onChange={e => {
                                        const val = e.target.value
                                        if (!val) return
                                        const found = allClientes.find(c => String(c.id) === val)
                                        if (found && !clientes.find(c => c.id === found.id)) {
                                            this.setState({ clientes: [...clientes, found] })
                                        }
                                        e.target.value = ""
                                    }}>
                                    <option value="">Seleccionar proyecto...</option>
                                    {allClientes.map(c => <option key={c.id} value={c.id}>{c.nombreCliente}</option>)}
                                </select>
                                {clientes.length > 0 && (
                                    <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                        {clientes.map(c => (
                                            <span key={c.id} className="cliente-chip">
                                                <button onClick={() => this.setState({ clientes: clientes.filter(x => x.id !== c.id) })}>✕</button>
                                                {c.nombreCliente}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>

                        </div>

                        <div style={styles.filtersFooter}>
                            <button className="btn-buscar" onClick={this.cargarDatos} disabled={loading}>
                                {loading ? '⏳ Cargando...' : '🔍 Buscar alertas'}
                            </button>
                            {loaded && (
                                <span style={styles.resultCount}>
                                    {totalAlertas} alerta{totalAlertas !== 1 ? 's' : ''} encontrada{totalAlertas !== 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Skeleton loader */}
                    {loading && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginTop: 24 }}>
                            {[1, 2, 3].map(i => (
                                <div key={i} style={{ background: 'white', borderRadius: 14, padding: 24, border: '1px solid #e8edf5' }}>
                                    <div className="skeleton" style={{ height: 20, width: '40%', marginBottom: 16 }} />
                                    {[1, 2, 3, 4].map(j => (
                                        <div key={j} className="skeleton" style={{ height: 14, width: '100%', marginBottom: 10 }} />
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Estado vacío */}
                    {!loading && !loaded && (
                        <div style={styles.emptyState}>
                            <div style={styles.emptyIcon}>🔔</div>
                            <h3 style={styles.emptyTitle}>Sin resultados aún</h3>
                            <p style={styles.emptyDesc}>Selecciona los filtros deseados y presiona <strong>Buscar alertas</strong> para cargar la información.</p>
                        </div>
                    )}

                    {!loading && loaded && alertasTables.length === 0 && (
                        <div style={styles.emptyState}>
                            <div style={styles.emptyIcon}>✅</div>
                            <h3 style={styles.emptyTitle}>Sin alertas</h3>
                            <p style={styles.emptyDesc}>No se encontraron alertas con los filtros seleccionados.</p>
                        </div>
                    )}

                    {/* Tablas */}
                    {!loading && alertasTables.map((t, i) => (
                        <div key={i} className="table-anim" style={{ animationDelay: `${i * 0.1}s` }}>{t}</div>
                    ))}
                </div>
            </div>
        )
    }
}

const styles = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px 28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 1200, margin: '0 auto' },
    pageHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 },
    pageTitle: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    pageSubtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    filtersCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '20px 24px', marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    filtersGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 16, marginBottom: 16 },
    filterGroup: { display: 'flex', flexDirection: 'column', gap: 6 },
    filterLabel: { fontSize: '0.68rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase' },
    filtersFooter: { display: 'flex', alignItems: 'center', gap: 16, paddingTop: 16, borderTop: '1px solid #f1f5f9' },
    resultCount: { fontSize: '0.82rem', color: '#64748b', fontWeight: 500 },
    tableWrap: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, marginBottom: 20, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    tableHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: '1px solid #f1f5f9' },
    tableHeaderLeft: { display: 'flex', alignItems: 'center', gap: 10 },
    tableTypeTag: { fontSize: '0.68rem', fontWeight: 700, background: '#eff6ff', color: '#3b82f6', border: '1px solid #bfdbfe', borderRadius: 20, padding: '3px 10px', letterSpacing: '1px', textTransform: 'uppercase' },
    tableTitle: { margin: 0, fontSize: '0.95rem', fontWeight: 700, color: '#1e293b' },
    countBadge: { fontSize: '0.75rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 20, padding: '3px 12px', color: '#64748b', fontWeight: 600 },
    tableScroll: { overflowX: 'auto' },
    table: { width: '100%', borderCollapse: 'collapse' },
    thead: { background: '#f8fafc' },
    th: { padding: '10px 16px', textAlign: 'left', fontSize: '0.72rem', fontWeight: 700, color: '#64748b', letterSpacing: '1px', textTransform: 'uppercase', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' },
    tr: { borderBottom: '1px solid #f1f5f9', transition: 'background 0.15s' },
    td: { padding: '12px 16px', fontSize: '0.83rem', color: '#334155', verticalAlign: 'top' },
    tdNum: { padding: '12px 16px', fontSize: '0.8rem', color: '#94a3b8', fontWeight: 600, width: 40 },
    link: { color: '#3b82f6', textDecoration: 'none', fontWeight: 600 },
    alertaBadge: { fontSize: '0.8rem', color: '#475569' },
    socBlock: { marginBottom: 8, paddingBottom: 8, borderBottom: '1px solid #f1f5f9' },
    roles: { display: 'flex', flexWrap: 'wrap', gap: 4, margin: '4px 0' },
    roleBadge: { fontSize: '0.7rem', background: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: 20, padding: '2px 8px', color: '#475569' },
    clienteBadge: { fontSize: '0.75rem', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 20, padding: '2px 8px', color: '#2563eb', display: 'inline-block', margin: '2px 2px 0 0' },
    emptyState: { textAlign: 'center', padding: '60px 20px', background: 'white', borderRadius: 16, border: '1px solid #e8edf5' },
    emptyIcon: { fontSize: '3rem', marginBottom: 12 },
    emptyTitle: { margin: '0 0 8px', fontSize: '1.1rem', fontWeight: 700, color: '#1e293b' },
    emptyDesc: { margin: 0, fontSize: '0.85rem', color: '#94a3b8', maxWidth: 360, marginLeft: 'auto', marginRight: 'auto' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 16px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 8 },
    pageInfo: { fontSize: '0.78rem', color: '#94a3b8' },
    pageBtn: (disabled) => ({ minWidth: 32, height: 32, padding: '0 8px', border: '1px solid #e2e8f0', borderRadius: 7, background: 'white', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '0.8rem', color: disabled ? '#cbd5e1' : '#475569', fontFamily: "'Inter', sans-serif", display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }),
    pageBtnActive: { minWidth: 32, height: 32, padding: '0 8px', border: '1px solid #3b82f6', borderRadius: 7, background: '#3b82f6', cursor: 'pointer', fontSize: '0.8rem', color: 'white', fontWeight: 700, fontFamily: "'Inter', sans-serif", display: 'inline-flex', alignItems: 'center', justifyContent: 'center' },
}

export default AlertasComponent
